import React, { useEffect } from "react";
import { Card, Row, Col, Typography, Button, Tag, Spin } from "antd";
import { ClockCircleOutlined,ExportOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { reducer, sliceKey, actions } from "./slice";
import { tatMonitoringSummarySaga } from "./saga";
import * as selectors from "./selectors";

const { Title, Text } = Typography;

const TATMonitoringSummary = ({
  filters = {},
  onDetailedClick = () => {},
}) => {
  useInjectReducer({ key: sliceKey, reducer });
  useInjectSaga({ key: sliceKey, saga: tatMonitoringSummarySaga });

  const dispatch = useDispatch();
 

  const loading = useSelector(selectors.selectLoading);
  const data = useSelector(selectors.selectSummaryData);

  const filterString = JSON.stringify(filters);

  useEffect(() => {
    dispatch(actions.fetchSummary({ filtersString: filterString }));
  }, [filterString, dispatch]);

  
  const tatMetrics = [
    { 
      label: "End-to-End TAT", 
      value: data?.endToEnd?.tat || 0, 
      target: data?.endToEnd?.target || 0 
    },
    { 
      label: "Sampling TAT", 
      value: data?.sampling?.tat || 0, 
      target: data?.sampling?.target || 0 
    },
    { 
      label: "Courier TAT", 
      value: data?.courier?.tat || 0, 
      target: data?.courier?.target || 0 
    },
    { 
      label: "Testing TAT", 
      value: data?.testing?.tat || 0, 
      target: data?.testing?.target || 0 
    },
  ];
return (
  <div style={{ background: "#f5f5f5" }}>
    {/* Custom Header */}
    <div
      style={{
        background: "#1e2a38",
        padding: "12px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
      }}
    >
      <Title level={4} style={{ color: "#fff", margin: 0 }}>
        <ClockCircleOutlined style={{ marginRight: 8 }} />
        TAT Monitoring
      </Title>
      <Button
        onClick={onDetailedClick}
        icon={<ExportOutlined style={{ color: "#fff" }} />}
        style={{
          backgroundColor: "#1e2a38",
          border: "1px solid #fff",
          color: "#fff",
        }}
      >
        Detailed View
      </Button>
    </div>

    {/* Body Content */}
    <div style={{ padding: 24 }}>
      {loading ? (
        <Spin />
      ) : (
        <Row gutter={[16, 16]}>
          {tatMetrics.map((item, index) => (
            <Col xs={24} sm={12} md={12} lg={12} key={index}>
              <Card
                bordered={false}
                style={{
                  background: "#fcfcfc",
                  textAlign: "center",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                }}
              >
                <Text type="secondary">{item.label}</Text>
                <Title level={3} style={{ margin: 0 }}>
                  {item.value} <span style={{ fontSize: 16 }}>days</span>
                </Title>
                <Tag
                  style={{
                    background: "#000",
                    color: "#fff",
                    borderRadius: "999px",
                    marginTop: 8,
                    padding: "4px 12px",
                    fontSize: 12,
                  }}
                >
                  Target: {item.target}
                </Tag>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  </div>
);


};

export default TATMonitoringSummary;